'use client';

import React, { useEffect } from 'react';

import CloseIcon from '@/assets/icons/cross-recommendation.svg';
import cn from '@/helpers/utils/classNames';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

import '@/styles/globals.v2.css';

import Image from 'next/image';

interface DetailModelProps {
  title?: string;
  isOpen: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  className?: string;
  contentClassName?: string;
  headerContainerClassName?: string;
  hideMainScroll?: boolean;
  titleChildren?: React.ReactNode;
  overlayContainerClass?: string;
  titleClassName?: string;
  closeIconClassName?: string;
  recommendationModal?: boolean;
}

const DetailModel: React.FC<DetailModelProps> = ({
  isOpen,
  title,
  onClose,
  contentClassName,
  hideMainScroll,
  children,
  className,
  titleChildren,
  headerContainerClassName,
  overlayContainerClass,
  titleClassName,
  closeIconClassName,
  recommendationModal,
}) => {
  useEffect(() => {
    if (isOpen && hideMainScroll) {
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, hideMainScroll]);

  if (!isOpen) return null;
  return (
    <div
      className={cn(
        'v2-fixed v2-inset-0 v2-z-50 v2-bg-gray-900 v2-bg-opacity-70 v2-backdrop-blur-lg v2-flex v2-justify-center v2-items-center',
        overlayContainerClass
      )}
    >
      <div
        className={cn(
          'v2-flex v2-flex-col v2-justify-start v2-items-center v2-bg-white v2-p-6 v2-w-full v2-mx-4 md:v2-mx-0 md:v2-w-[640px] v2-relative v2-rounded-xl',
          className
        )}
      >
        {/* <Image
          src={bgMaskIcon}
          alt=""
          className="v2-absolute v2-left-0 v2-top-0 before:v2-w-[350px] before:v2-h-[350px] before:v2-bg-black before:v2-absolute before:top-0"
        /> */}
        <div
          className={cn(
            'v2-flex v2-justify-between v2-items-center v2-w-full v2-relative v2-z-[2] v2-mb-[4px]',
            headerContainerClassName
          )}
        >
          <p
            className={cn(
              'v2-text-start v2-font-sweet-sans-pro v2-font-normal v2-text-[#101828] v2-text-2xl v2-leading-8 v2-flex',
              titleClassName
            )}
          >
            {title}
            {titleChildren}
          </p>
          <div onClick={onClose}>
            {recommendationModal ? (
              <Image
                src={CloseIcon}
                alt="open filters"
                className={cn(
                  '!v2-w-[30.01px] !v2-h-[30.01px] v2-text-[#E8ECEB] hover:v2-text-[#E8ECEB] v2-cursor-pointer',
                  closeIconClassName
                )}
              />
            ) : (
              <CloseOutlinedIcon
                className={cn(
                  'v2-w-6 v2-h-6 v2-text-[#98A2B3] v2-cursor-pointer v2-rounded hover:v2-text-[#8f98a8]',
                  closeIconClassName
                )}
              />
            )}
          </div>
        </div>
        <div className={cn('v2-w-full v2-relative v2-z-[2]', contentClassName)}>{children}</div>
      </div>
    </div>
  );
};
export default DetailModel;
